import React, { useEffect, useState } from "react";
import CompanySelect from "../../../../Inputs/CompanySelect/CompanySelect";
import AddCompany from "../../../AddCompany/AddCompany";
import MaintenanceScheduleInputs from "../../../../Inputs/MaintenanceScheduleInputs/MaintenanceScheduleInputs";
import { useDispatch, useSelector } from "react-redux";
import {
  createMaintenanceSchedule,
  getAllMaintenanceScheduleById,
  updateMaintenanceSchedule,
} from "../../../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";
import notify from "../../../../../hooks/useNotifaction";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function AddMaintenanceScheduleCarousel({
  activeTab,
  handleSubmit,
  users,
  loading,
  pathname,
  ScheduleId,
  maintenanceSchedules,
  setMaintenanceSchedules,
  status,
  contracts,
}) {
  return (
    <>
      <div className="mt-5 companySection">
        <div className="mx-5">
          <div className={false ? "main" : ""}>
            {true && <h2 className="text-white mb-4">اضافة جدول</h2>}
            <form onSubmit={handleSubmit}>
              <div
                className={
                  false
                    ? "card mb-3 pt-5 pb-2 px-3 companyProfile"
                    : "mb-3 pt-5 pb-2 px-3 companyProfile"
                }
              >
                <MaintenanceScheduleInputs
                  users={users}
                  maintenanceSchedules={maintenanceSchedules}
                  setMaintenanceSchedules={setMaintenanceSchedules}
                  contracts={contracts}
                />
                <div>
                  {pathname ==
                  `/ShowMoreMaintenanceSchedule/${ScheduleId}` ? null : (
                    <button type="submit" className="btn btn-primary">
                      <i className="fas fa-plus me-1"></i>
                      {ScheduleId ? "تعديل " : "إضافة"}
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between mx-5 my-3">
        <div></div>
        <button
          className={`btn btn-primary ${status === "succeeded" && !loading ? "" : "d-none"}`}
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          التالي
        </button>
      </div>
    </>
  );
}
